import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1024.000000 1024.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)">

<path d="M1176 6248 l5 -193 562 -3 c444 -1 561 -5 559 -15 -2 -6 -20 -41 -41
-77 -44 -74 -171 -300 -461 -815 -112 -198 -258 -457 -325 -575 -160 -282
-309 -547 -328 -585 -8 -17 -19 -63 -22 -103 l-8 -72 957 0 956 0 0 210 0 210
-621 0 c-496 0 -619 3 -611 13 5 6 43 73 85 147 41 74 162 290 269 480 107
190 248 440 313 555 65 116 195 347 290 515 153 271 265 480 265 495 0 3 -416
5 -924 5 l-925 0 5 -192z"/>
<path d="M4300 6355 l0 -75 205 0 c113 0 205 -3 205 -8 0 -4 -33 -52 -74 -107
-260 -349 -322 -430 -328 -433 -5 -2 -8 -37 -8 -78 l0 -74 320 0 321 1 -3 77
-3 77 -204 2 c-112 1 -205 3 -207 5 -2 2 91 129 206 283 l210 279 0 63 0 63
-320 0 -320 0 0 -75z"/>
<path d="M5323 6413 c-3 -10 -15 -40 -26 -68 -65 -167 -277 -744 -277 -755 0
-6 40 -10 94 -10 l94 0 26 78 c15 42 30 83 34 90 7 9 46 12 162 10 l153 -3 26
-77 c14 -42 29 -79 32 -83 12 -12 190 -11 187 1 -2 6 -73 196 -158 422 l-155
412 -93 0 c-79 0 -94 -3 -99 -17z m152 -340 c27 -82 50 -154 53 -160 3 -10
-21 -13 -102 -13 -88 0 -106 3 -106 15 0 23 93 305 100 305 4 0 28 -66 55
-147z"/>
<path d="M5928 6008 l2 -423 268 0 267 0 1 78 1 77 -184 0 -183 0 0 100 0 100
160 0 160 0 0 70 0 70 -160 0 -160 0 0 100 0 100 186 0 185 0 -2 75 -2 75
-271 0 -271 0 3 -422z"/>
<path d="M6610 6005 l0 -426 88 3 87 3 -1 273 c-1 149 1 272 3 272 10 0 48
-53 215 -297 l173 -252 83 -1 82 0 0 425 0 425 -87 0 -88 0 3 -277 c1 -152 0
-275 -2 -272 -3 3 -90 126 -194 275 l-189 269 -86 3 -87 3 0 -426z"/>
<path d="M7493 6123 c3 -170 11 -324 17 -344 25 -88 116 -168 215 -190 29 -6
96 -10 156 -7 153 6 226 43 287 148 l27 45 3 328 3 327 -85 0 -85 0 -3 -292
c-3 -257 -5 -297 -21 -329 -25 -50 -80 -79 -151 -79 -74 0 -125 22 -156 67
l-25 36 -3 299 -3 298 -91 0 -91 0 6 -307z"/>
<path d="M8358 6004 l2 -425 270 3 270 3 0 78 0 77 -185 0 -185 0 0 345 0 345
-87 0 -88 0 3 -426z"/>
<path d="M2995 5868 c-229 -432 -252 -476 -339 -643 -43 -82 -93 -177 -111
-210 -52 -96 -118 -222 -180 -340 -32 -60 -73 -136 -91 -167 l-33 -58 657 0
657 0 157 -320 157 -320 225 0 c124 0 226 2 226 4 0 4 -109 231 -285 591 -59
121 -140 288 -180 370 -580 1198 -677 1395 -689 1395 -7 0 -84 -136 -171 -302z
m270 -800 l113 -233 -230 -3 c-127 -1 -233 0 -237 3 -7 7 221 464 232 465 5 0
59 -105 122 -232z"/>
<path d="M4551 5327 c-5 -12 -74 -198 -155 -413 -80 -215 -146 -394 -146 -398
0 -3 42 -6 94 -6 l93 0 33 85 33 85 158 0 c108 0 159 -3 159 -11 0 -6 12 -44
26 -85 l27 -74 93 0 c52 0 94 2 94 4 0 9 -298 794 -309 814 -5 10 -37 15 -100
18 -87 3 -92 3 -100 -19z m158 -340 c28 -84 51 -156 51 -160 0 -4 -47 -7 -105
-7 -77 0 -105 3 -106 13 0 19 95 307 103 307 3 0 29 -69 57 -153z"/>
<path d="M5150 4929 l0 -421 228 4 227 3 55 30 c100 55 146 175 106 280 -19
48 -72 101 -111 111 -24 6 -35 24 -16 24 19 0 72 53 91 91 57 111 -23 249
-164 283 -16 4 -116 9 -222 11 l-194 4 0 -420z m386 255 c35 -25 47 -68 33
-111 -17 -53 -41 -63 -151 -63 l-98 0 0 101 0 101 94 -4 c76 -2 100 -7 122
-24z m35 -343 c23 -24 29 -38 29 -75 0 -87 -50 -114 -212 -115 l-68 -1 0 110
0 110 111 0 c109 0 111 0 140 -29z"/>
<path d="M5900 4931 l0 -421 88 0 87 0 -2 417 -3 418 -85 3 -85 3 0 -420z"/>
<path d="M6230 4932 l0 -422 178 0 c122 0 197 5 241 15 218 52 344 244 311
477 -24 168 -122 280 -285 325 -30 8 -129 16 -247 20 l-198 6 0 -421z m396
242 c64 -22 101 -51 132 -104 24 -40 27 -56 27 -135 0 -80 -3 -95 -28 -137
-52 -89 -134 -128 -270 -128 l-82 0 0 260 0 260 87 0 c54 0 105 -6 134 -16z"/>
<path d="M7090 4929 l0 -419 265 0 265 0 0 75 0 75 -180 0 -180 0 0 100 0 100
160 0 160 0 0 70 0 70 -160 0 -160 0 0 98 0 97 177 0 178 0 0 75 0 75 -262 1
-263 2 0 -419z"/>
<path d="M7760 4930 l0 -420 270 0 270 0 0 75 0 75 -182 0 -183 0 0 97 1 98
157 3 157 3 0 69 0 70 -160 0 -161 0 3 96 3 95 175 2 175 2 3 75 3 75 -266 3
-265 2 0 -420z"/>
<path d="M8424 5339 c-2 -4 -1 -192 2 -418 l7 -411 85 0 85 0 -6 270 c-4 164
-3 269 3 265 5 -3 90 -125 190 -270 l182 -265 84 0 84 0 -2 416 -3 416 -83 1
-83 0 1 -278 1 -277 -43 63 c-207 307 -335 482 -357 491 -28 10 -140 8 -147
-3z"/>
<path d="M4830 4010 l0 -250 103 0 c220 0 313 67 325 233 6 85 -16 148 -70
199 -53 51 -116 68 -250 68 l-108 0 0 -250z m249 142 c50 -25 74 -63 79 -125
9 -109 -58 -176 -175 -177 l-53 0 0 160 0 160 58 0 c34 0 70 -7 91 -18z"/>
<path d="M5491 4238 c-5 -13 -45 -120 -90 -238 -44 -119 -81 -221 -81 -228 0
-8 17 -12 49 -12 l50 0 19 53 20 52 92 0 92 0 20 -52 19 -53 53 0 53 0 -79
208 c-44 114 -87 226 -95 250 -15 42 -15 42 -64 42 -42 0 -51 -3 -58 -22z m88
-197 c17 -47 31 -86 31 -88 0 -2 -27 -3 -60 -3 -33 0 -60 3 -60 6 0 13 52 175
55 172 2 -2 17 -41 34 -87z"/>
<path d="M5792 4218 l3 -43 68 -3 67 -3 0 -204 0 -205 50 0 50 0 0 205 0 205
70 0 70 0 0 45 0 45 -191 0 -190 0 3 -42z"/>
<path d="M6350 4256 c0 -4 -160 -442 -175 -478 -6 -16 -1 -18 48 -18 l54 0 20
53 20 52 95 3 95 3 18 -56 19 -55 53 0 c29 0 53 2 53 4 0 2 -9 26 -21 53 -18
42 -86 218 -151 391 l-19 52 -55 0 c-30 0 -54 -2 -54 -4z m104 -250 c9 -21 16
-42 16 -47 0 -5 -27 -9 -60 -9 -71 0 -71 -1 -33 111 l26 79 17 -48 c10 -26 25
-64 34 -86z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
